'use client';

import type { PropsWithChildren } from 'react';
import { useGuest } from '../hooks/useGuest';
import { AuthInfo } from './AuthInfo/AuthInfo';
import { LoginDialog } from './Dialog/LoginDialog/LoginDialog';
import { MainLoader } from './Loader';
import { useApiErrorContext, useAuthenticatedContext } from './Provider';

export function AuthenticatedGuard({ children, checkGuestId }: PropsWithChildren<{ checkGuestId?: number }>) {
  const { isAuthenticated, isAuthenticating } = useAuthenticatedContext();
  const { status } = useApiErrorContext();

  const { allowed } = useGuest(isAuthenticated === false && !!checkGuestId, checkGuestId);

  if (isAuthenticating || typeof isAuthenticated !== 'boolean') {
    return <MainLoader />;
  }

  return (
    <>
      {((!isAuthenticated && (
        <AuthInfo guestAllowed={allowed} />
      ))) || children}
      {!!status && status === 401 && (
        <LoginDialog />
      )}
    </>
  );
}
